import React, { useState } from "react";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
} from "@mui/material";

const CustomerTransactionDetails = () => {
  const [value, setValue] = useState("asc");

  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setValue(event.target.value);
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Customer Transaction Details</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Branch"
                          placeholder={"Branch"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Customer Type"
                          placeholder={"Customer Type"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDropDown
                          label="Customer Name"
                          placeholder={"Customer Name"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="From Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiDatePicker
                          label="To Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiDropDown
                          label="Product Type   "
                          placeholder={"Product Type"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiDropDown
                          label="Payment Mode"
                          placeholder={"Payment Mode"}
                          options={[]}
                          onChange={function (value: string, id: string): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <Box
                          border={1}
                          borderColor="grey.300"
                          borderRadius={1}
                          px={2}
                          width="fit-content"
                        >
                          <FormControl component="fieldset">
                            <FormLabel
                              component="legend"
                              sx={{ color: "orange", fontWeight: "bold", marginBottom:"-4px" }}
                            >
                              Order By
                            </FormLabel>
                            <RadioGroup
                              row
                              value={value}
                              onChange={handleChange}
                              aria-label="order"
                              name="order-radio-buttons-group"
                            >
                              <FormControlLabel
                                value="asc"
                                control={<Radio />}
                                label="Asc"
                              />
                              <FormControlLabel
                                value="desc"
                                control={<Radio />}
                                label="Desc"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Box>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Get"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CustomerTransactionDetails;
